import styled from "styled-components";
import theme from "../../../styles/theme";

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: fit-content;
  align-items: center;
  .img {
    margin-left: 5vw;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 20vw;
    padding: 1.5em;
    .logo {
      width: 100%;
      will-change: filter;
      transition: filter 300ms;
    }
  }
`;
export const NavContainer = styled.div`
  display: flex;
  flex-direction: row;
  /* margin-left: 4vh; */
  /* margin-top: 4vh; */
  column-gap: 1.5vw;
  height: fit-content;
  width: 100%;
  .item {
    font-size: ${theme.fontSize.mm};
    color: black;
  }
  .item-active {
    color: ${theme.colors.brown.capivara};
    font-size: ${theme.fontSize.mm};
  }
  .logout {
    color: red;
    font-size: ${theme.fontSize.mm};
    display: flex;
    column-gap: 0.5vw;
    cursor: pointer;
    align-items: center;
  }
`;

export const RightNav = styled.div`
  margin-left: auto;
  margin-right: 2vw;
  display: flex;
  flex-direction: row;
`;
export const SearchCounter = styled.div`
  font-size: ${theme.fontSize.mm};
  display: flex;
  flex-direction: row;
  color: blue;
  column-gap: 0.5vw;
  align-items: center;
  margin-right: 3vw;
  border-style: solid;
  border-width: 1px;
  border-radius: 25px;
  padding-inline: 1vw;
`;
export const SearchCounterMobile = styled.div`
  display: flex;
  flex-direction: column;
  color: blue;
  margin-bottom: 2vh;
  .row {
    font-size: ${theme.fontSize.sm};
    display: flex;
    flex-direction: row;
    column-gap: 0.5vw;
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  background-color: ${theme.colors.palete.brownLighter};
  /* position: absolute; */
`;

export const HomeContainer = styled.div`
  .logoImg {
    height: 11vh;
    margin-left: 1vw;
    margin-bottom: -2vh;
    margin-top: -1vh;
  }
  @media (${theme.devices.tablet}) {
    .logoImg {
      height: 90px;
      width: 300px;
      margin-bottom: -12px;
    }
  }
`;
export const MobileHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  place-content: center;
  .home {
    display: flex;
    font-size: ${theme.fontSize.xxlg};
    margin-top: 2vh;
  }
`;
export const MenuItem = styled.a`
  display: inline-block;
  transition: transform 0.8s cubic-bezier(0.7, 0, 0.3, 1) 0s;
  text-decoration: none;
  font-size: 2.1875em;
  font-size: ${theme.fontSize.md};
  margin-bottom: 0.5vw;
`;
export const BottomItens = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  margin-bottom: 2vh;
`;
export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 0.2vw;
  color: ${theme.colors.palete.brownDark};
  font-family: sans-serif;
  font-weight: 800;
  align-items: center;
  margin-right: 3px;
`;
